import React, { useCallback, useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Badge, Box, Button, Grid, IconButton, List, ListItem, SwipeableDrawer, Typography, useTheme } from '@material-ui/core';
import { Close, ArrowBack } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import { COLORS } from '../../../shared/Theme';
import { TitleBarWithButton } from '../../../shared/header/TitleBar';
import { basic, member as v_member, Values, SNACKBAR_TIME, product as v_product } from '../../../request/values';
import { formatMoney, formatMoneyAmount, getTranslatedLicenseName, getTranslatedMaterialName } from '../../../locales/formatModule';
import ToastStr from '../../../request/toastStr';
import { CartItem, useCartStore } from '../../../stores/useCartStore';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	list: {
		padding: '1vw',
		height: '69.5vh',
		overflowY: 'auto',
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		fontSize: '4vw',
		//alignContent: 'center',
		[theme.breakpoints.up('md')]: {
			height: '100%',
			paddingBottom: theme.spacing(15),
		},
	},
	drawerOpenList: {
		height: '50vh',
	},

	materialItem: {
		// borderRadius: 12,
		border: `solid 1px ${COLORS.VERY_LIGHT_PINK}`,
		marginBottom: '1.5vh',
		padding: 0,
		borderRadius: '5px',
	},
	materialImage: {
		textAlign: 'center',
		margin: 'auto',
		'& img': {
			width: '14vw',
			maxWidth: '100px',
			[theme.breakpoints.up('lg')]: {
				width: '55px',
			},
		},
	},
	icon: {
		width: '5vw',
		maxWidth: '38px',
	},
	materialDesc: {
		'& #materialName': {
			...theme.typography.subtitle2,
		},
		'& #materialSubName': {
			...theme.typography.body1,
			//color: `${COLORS.BROWNISH_GREY}`,
			color: `${COLORS.WATER_BLUE}`,
		},
	},
	materialButtonSection: {
		'& #price': {
			margin: 'auto',
			textAlign: 'center',
			...theme.typography.subtitle2,
		},
		'& #count': {
			margin: 'auto',
			textAlign: 'center',
			...theme.typography.subtitle2,
		},
	},

	materialBottomBar: {
		position: 'fixed',
		bottom: 0,
		left: 0,
		right: 0,
		display: 'block',
		width: '100%',
		height: '11vh',
		// marginLeft: '-2.5vw',
		backgroundColor: `${COLORS.LIGHT_GREY}`,

		'& #saleButton': {
			borderRadius: '10px',
			boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
			backgroundColor: `${COLORS.WHITE}`,
			color: `${COLORS.WATER_BLUE}`,
			...theme.typography.h4,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
		},
		'& .MaterialBottomicon': {
			width: '7.4vw',
			maxWidth: '60px',
		},
		[theme.breakpoints.up('md')]: {
			width: 'calc(100% - 290px)',
			left: '290px',
		},
	},
	drawerOpenBomttomBar: {
		height: '32vh',
	},

	basketItem: {
		display: 'flex',
		width: '93vw',
		height: '6.5vh',
		alignItems: 'center',

		padding: '1vh 4vw',
		fontFamily: 'NanumB',
		fontWeight: 'bold',

		borderRadius: '12px',
		border: 'solid 1px #e4e4e4',
		backgroundColor: `${COLORS.WHITE}`,
		// "& img": {
		//     width: '9vw',
		// }
		'& #imageSection': {
			width: '20%',
		},
		'& #imageSection img': {
			width: '50%',
		},

		'& #nameSection': {
			width: '48%',
			color: `${COLORS.CHARCOAL_GREY}`,
		},

		'& #descSection': {
			textAlign: 'right',
			width: '18%',
			fontSize: '3vw',
		},
		[theme.breakpoints.up('md')]: {
			height: '11.5vh',
		},
	},

	empty: {
		height: '58vh',
		textAlign: 'center',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& img': {
			width: '35vw',
			height: '35vw',
			[theme.breakpoints.up('md')]: {
				width: '25vw',
				height: '25vw',
			},
			marginBottom: '2.5vh',
		},
		'& h1': {
			color: `${COLORS.DOWN}`,
		},
	},
	drawerPaper: {
		borderTopLeftRadius: '16px',
		borderTopRightRadius: '16px',
		maxHeight: '72vh',
		overflow: 'hidden',
	},
	bottomSheet: {
		display: 'flex',
		flexDirection: 'column',
		maxHeight: '72vh',
		backgroundColor: COLORS.WHITE,
		padding: theme.spacing(2),
		paddingTop: theme.spacing(1),
	},
	sheetContent: {
		flex: 1,
		minHeight: 0,
		display: 'flex',
		flexDirection: 'column',
	},
	sheetContentScroll: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
		WebkitOverflowScrolling: 'touch',
		marginBottom: theme.spacing(1),
	},
	analysisListScroll: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
		WebkitOverflowScrolling: 'touch',
		marginBottom: theme.spacing(1),
	},
	sheetFooter: {
		flexShrink: 0,
		paddingTop: theme.spacing(1.5),
		paddingBottom: 'max(4px, env(safe-area-inset-bottom))',
	},
	sheetHandle: {
		width: '40px',
		height: '4px',
		borderRadius: '2px',
		backgroundColor: '#d0d0d0',
		margin: '0 auto',
	},
	sheetHandleArea: {
		padding: '12px 0 16px',
		display: 'flex',
		justifyContent: 'center',
		flexShrink: 0,
	},
	sheetHeader: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: theme.spacing(1.5),
		'& h2': {
			flex: 1,
			textAlign: 'center',
			color: COLORS.WATER_BLUE,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
			fontSize: '1.1rem',
			margin: 0,
			[theme.breakpoints.up('md')]: {
				fontSize: '1.3rem',
			},
		},
	},
	productGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(2, 1fr)',
		gap: theme.spacing(1.5),
		[theme.breakpoints.up('sm')]: {
			gridTemplateColumns: 'repeat(3, 1fr)',
		},
	},
	productCard: {
		border: 'solid 1px #e4e4e4',
		borderRadius: '10px',
		padding: theme.spacing(1.5),
		textAlign: 'center',
		cursor: 'pointer',
		backgroundColor: COLORS.WHITE,
		WebkitTapHighlightColor: 'transparent',
		'&:active': {
			backgroundColor: COLORS.WHITE,
		},
	},
	productCardSelected: {
		border: `solid 2px ${COLORS.WATER_BLUE}`,
	},
	companyCardSelected: {
		backgroundColor: COLORS.WATER_BLUE,
		border: `solid 2px ${COLORS.WATER_BLUE}`,
		color: COLORS.WHITE,
		'& .MuiTypography-root': {
			color: COLORS.WHITE,
		},
		'&:active': {
			backgroundColor: COLORS.WATER_BLUE,
		},
	},
	productCardImage: {
		width: '100%',
		height: '12vh',
		objectFit: 'contain',
		marginBottom: theme.spacing(1),
	},
	productBadgeComplete: {
		display: 'inline-block',
		marginTop: theme.spacing(0.5),
		padding: '2px 8px',
		borderRadius: '12px',
		fontSize: '2.6vw',
		backgroundColor: COLORS.LIGHT_GREEN,
		color: COLORS.GREEN,
		fontWeight: 'bold',
		[theme.breakpoints.up('md')]: {
			fontSize: '14px',
		},
	},
	analyzeBtn: {
		fontSize: '0.9rem',
		width: '100%',
		marginTop: 0,
		padding: '2vw 0',
		borderRadius: '8px',
		backgroundColor: COLORS.WATER_BLUE,
		color: COLORS.WHITE,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		'&:disabled': {
			background: '#BDBDBD',
			color: '#fff',
		},
		[theme.breakpoints.up('md')]: {
			fontSize: '1.2rem',
			padding: '1vw 0',
		},
		'@media (hover: none)': {
			'&:hover:not(:disabled)': {
				backgroundColor: COLORS.WATER_BLUE,
			},
		},
	},
	analysisAlert: {
		padding: theme.spacing(1.5),
		borderRadius: '8px',
		backgroundColor: COLORS.LIGHT_GREY,
		marginBottom: theme.spacing(2),
		color: COLORS.CHARCOAL_GREY,
	},
	analysisSuccess: {
		padding: theme.spacing(2),
		borderRadius: '8px',
		backgroundColor: COLORS.VERY_LIGHT_GREEN,
		marginBottom: theme.spacing(2),
		textAlign: 'center',
		color: COLORS.GREEN,
	},
	analysisSectionTitle: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		color: COLORS.CHARCOAL_GREY,
	},
	analysisItem: {
		display: 'flex',
		alignItems: 'center',
		padding: '1vh 2vw',
		borderRadius: '8px',
		marginBottom: theme.spacing(1),
		border: `solid 1px ${COLORS.VERY_LIGHT_PINK}`,
	},
	analysisItemShortage: {
		backgroundColor: COLORS.VERY_LIGHT_PUMPKIN,
	},
	analysisItemCorrect: {
		backgroundColor: COLORS.VERY_LIGHT_GREEN,
	},
	analysisItemUnnecessary: {
		backgroundColor: COLORS.VERY_LIGHT_RED,
	},
	analysisItemImage: {
		width: '12vw',
		maxWidth: '48px',
		marginRight: theme.spacing(1.5),
	},
	analysisBadge: {
		marginLeft: 'auto',
		padding: '4px 10px',
		borderRadius: '14px',
		fontWeight: 'bold',
		whiteSpace: 'nowrap',
	},
	analysisBadgeShortage: {
		backgroundColor: COLORS.LIGHT_PUMPKIN,
		color: COLORS.PUMPKIN,
	},
	analysisBadgeCorrect: {
		backgroundColor: COLORS.PALE_GREEN,
		color: COLORS.GREEN,
	},
	analysisBadgeUnnecessary: {
		backgroundColor: COLORS.LIGHT_RED,
		color: COLORS.RED,
	},
}));

interface iMaterialList {
	materialCode: number;
	materialName: string;
	materialSubName: string;
	materialImage: string;
	materialPrice: number;
	materialCount: number;
}

interface iCompanyInfo {
	company_num: number;
	company_name: string;
}

const MaterialPurchase: React.FC<any> = (props) => {
	const classes = useStyles();
	const { member } = props;
	const history = useHistory();
	const { t } = useTranslation('student');
	const { t: tObject } = useTranslation('object');

	const { cart, totalPrice, totalQuantity, increaseQuantity, decreaseQuantity, clearCart } = useCartStore();

	const getMaterialByCode = (materialCode: number) => material.find((m) => m.materialCode === materialCode);
	const getCartQuantity = (materialCode: number) => cart.find((c) => c.materialCode === materialCode)?.quantity || 0;

	const toCartItemInput = (item: iMaterialList): Omit<CartItem, 'quantity'> => ({
		materialCode: item.materialCode,
		materialPrice: item.materialPrice,
	});
	const [material, setMaterial] = useState<iMaterialList[]>([]);
	const cartWithDetails = cart
		.map((cartItem) => {
			const materialItem = getMaterialByCode(cartItem.materialCode);
			if (!materialItem) return null;
			return {
				...materialItem,
				materialPrice: cartItem.materialPrice,
				quantity: cartItem.quantity,
			};
		})
		.filter((item): item is iMaterialList & { quantity: number } => item != null);

	const [companyList, setCompanyList] = useState<iCompanyInfo[]>([]);
	const [drawer, setDrawer] = useState<boolean>(false);
	const [purchaseOpen, setPurchaseOpen] = useState(false);
	const [purchaseStep, setPurchaseStep] = useState<'product' | 'analysis' | 'company'>('product');
	const [selectedCompany, setSelectedCompany] = useState<number>(0);
	const [productList, setProductList] = useState<any[]>([]);
	const [selectedProduct, setSelectedProduct] = useState<any>(null);
	const [cartCheck, setCartCheck] = useState<any>(null);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const count = 20;
	let max_count: number = 999;

	const [page, setPage] = useState(-count);
	const loader = useRef(null);

	const theme = useTheme();
	const isLargeUp = useMediaQuery(theme.breakpoints.up('lg'));

	const handleObserver = useCallback((entries: any) => {
		const target = entries[0];
		if (target.isIntersecting) {
			setPage((prevState) => {
				if (prevState + count > max_count) {
					return prevState;
				}
				return prevState + count;
			});
		}
	}, []);

	const moveMaterialPurchaseList = () => {
		history.push({
			pathname: '/MaterialPurchaseList',
		});
	};

	// 재료 구매
	const handleOpenPurchasePanel = () => {
		if (cart.length === 0) {
			enqueueSnackbar(ToastStr.MATERIAL_PURCHASE_EMPTY_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
			return;
		}
		getCompletedProductList().then(() => {
			setPurchaseOpen(true);
		});
	};

	// 제품 선택
	const handleSelectProduct = (item: any) => {
		if (selectedProduct?.licenseNum === item.licenseNum) {
			setSelectedProduct(null);
		} else {
			setSelectedProduct(item);
		}
	};

	const handleDrawerOpen = () => {
		if (cart.length > 0) {
			setDrawer((prevState) => !prevState);
		}
	};

	const setShoppingCart = (e: any, item: iMaterialList, status: string) => {
		e.preventDefault();

		if (status === '+') {
			increaseQuantity(toCartItemInput(item));
		} else if (status === '-' && getCartQuantity(item.materialCode) > 0) {
			decreaseQuantity(item.materialCode);
		}
	};

	const AddComma = (num: number) => {
		var regexp = /\B(?=(\d{3})+(?!\d))/g;
		return num.toString().replace(regexp, ',');
	};

	// 재료 목록과 장바구니 목록 비교
	const compareCartList = (menual: any[], cartList: CartItem[]) => {
		let shortage: any[] = [];
		let correct: any[] = [];
		let unnecessary: any[] = [];
		let overQty: any[] = [];

		let menualMap = new Map(menual.map((item) => [String(item.materialCode), item]));
		let cartMap = new Map(cartList.map((item) => [String(item.materialCode), item]));
		let materialMap = new Map(material.map((item) => [String(item.materialCode), item]));

		// 재료 목록과 장바구니 목록에 있는 재료 코드 합침
		let allUniqueCodes = new Set([...menualMap.keys(), ...cartMap.keys()]);

		allUniqueCodes.forEach((code) => {
			let menualItem = menualMap.get(code);
			let cartItem = cartMap.get(code);

			let required = menualItem ? menualItem.materialCount : 0; // 재료 목록에 없으면 0개 필요
			let current = cartItem ? cartItem.quantity : 0; // 장바구니에 없으면 0개 담김

			// 기본 정보 세팅
			let info = menualItem || materialMap.get(code);
			if (!info) return;
			let baseData = {
				materialCode: info.materialCode,
				materialName: info.materialName,
				materialSubName: info.materialSubName,
				materialImage: info.materialImage,
				required: required,
				current: current,
				shortage: 0,
				extra: 0,
			};

			if (required > 0 && current < required) {
				// 적게 산 경우
				shortage.push({ ...baseData, shortage: required - current });
			} else if (required === 0 && current > 0) {
				// 필요 없는 재료가 있는 경우
				unnecessary.push({ ...baseData, extra: current });
			} else if (required > 0 && current > required) {
				// 너무 많이 산 경우
				overQty.push({ ...baseData, extra: current - required });
			} else if (required > 0 && current === required) {
				// 정확하게 딱 맞춰 산 경우
				correct.push(baseData);
			}
		});

		return { shortage, correct, unnecessary, overQty };
	};

	async function getMaxMaterialCount(): Promise<number> {
		let url = new URL(basic.server + v_member.member + v_member.material_count);
		let params = { classVersion: member.classVersion };
		url.search = new URLSearchParams(params).toString();

		const response = await axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		});
		const data = await response.data;
		const count: number = data.count.count;
		return count;
	}

	const getCompanyList = () => {
		let url = new URL(basic.server + v_member.member + v_member.decompose_company_list);
		let params = { classCode: member.classCode };
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code == Values.SUCCESS_CODE) {
					setCompanyList(data.companyList);
				}
			});
	};

	const getMaterialList = (position: number, count: number) => {
		// console.log('in getMaterialList position', position);

		let url = new URL(basic.server + v_member.member + v_member.material_list);
		let params = {
			position: position.toString(),
			count: count.toString(),
			classVersion: member.classVersion,
		};
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code == Values.SUCCESS_CODE) {
					setMaterial((prevState) => prevState.concat(data.materials));
				}
			});
	};

	// 연구개발 완료된 제품 목록 조회
	const getCompletedProductList = () => {
		let url = new URL(SERVER + v_member.member + v_product.sale_product_list);
		let params = { companyNum: member.companyNum.toString(), classVersion: member.classVersion };
		url.search = new URLSearchParams(params).toString();

		return axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code != Values.SUCCESS_CODE) return;

				setProductList(data.products || []);
			});
	};

	// 제품에 대한 재료 목록 조회 + 장바구니 재료 확인
	const getLicenseManual = () => {
		if (!selectedProduct) return;

		let url = new URL(SERVER + v_member.member + v_member.license_manual);
		let params = { licenseNum: selectedProduct.productLicenseLevel.toString(), classVersion: member.classVersion.toString() };
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code != Values.SUCCESS_CODE) return;

				setCartCheck(compareCartList(data.materials || [], cart));
				setPurchaseStep('analysis');
			});
	};

	const postMaterialOrderCompany = (companyNum: number) => {
		if (companyNum === undefined || companyNum === 0) {
			enqueueSnackbar(t('MaterialPurchase.selectCompany'), {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
			return;
		}

		let url = new URL(basic.server + v_member.member + v_member.material_order);
		if (cart.length === 0) {
			setPurchaseOpen(false);
			return;
		}

		axios({
			method: 'POST',
			data: {
				companyNum: member.companyNum,
				classCode: member.classCode,
				memberEmail: member.id,
				memberName: member.name,
				cartList: cart,
				decomposeCompanyNum: companyNum,
				productNum: selectedProduct.productNum,
				licenseNum: selectedProduct.licenseNum,
			},
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code == Values.SUCCESS_CODE) {
					clearCart();
					setSelectedProduct(null);
					setCartCheck(null);
					enqueueSnackbar(ToastStr.MATERIAL_PURCHASE_SUCCESS_STR, {
						variant: 'success',
						autoHideDuration: SNACKBAR_TIME,
					});
					// props.setLicenseStatus(e, 'complete', data.regDate.development_date)
				} else if (data.code == Values.INSUFFICIENT_CODE) {
					enqueueSnackbar(ToastStr.MATERIAL_PURCHASE_NO_CASH_STR, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else if (data.code == Values.CLASS_FINISH_CODE) {
					enqueueSnackbar(ToastStr.CLASS_ALREADY_END_STR, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else if (data.code == Values.FAIL_CODE) {
					if (data.msg)
						enqueueSnackbar(data.msg, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
					else
						enqueueSnackbar(ToastStr.MATERIAL_PURCHASE_FAIL_STR, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
				} else {
					if (data.msg) enqueueSnackbar(data.msg, { variant: 'error' });
					else
						enqueueSnackbar(ToastStr.MATERIAL_PURCHASE_FAIL_STR, {
							variant: 'error',
							autoHideDuration: SNACKBAR_TIME,
						});
				}
			});
		setPurchaseOpen(false);
	};

	useEffect(() => {
		const option = {
			root: null,
			rootMargin: '20px',
			threshold: 0,
		};
		// console.log('in infinite useEffect')
		const observer = new IntersectionObserver(handleObserver, option);
		if (loader.current) observer.observe(loader.current!);
	}, [handleObserver]);

	useEffect(() => {
		const init = async () => {
			getCompanyList();
			max_count = await getMaxMaterialCount();
		};
		init();
	}, []);

	useEffect(() => {
		if (page >= 0) {
			getMaterialList(page, count);
		}
	}, [page]);

	const selectedProductName = selectedProduct ? getTranslatedLicenseName(tObject, selectedProduct.productName) : '';
	const showAnalysis = purchaseStep === 'analysis' && cartCheck != null;
	const showCompany = purchaseStep === 'company';
	const wrongList =
		cartCheck == null
			? []
			: [
					...cartCheck.shortage.map((item: any) => ({ ...item, status: 'shortage' })),
					...cartCheck.overQty.map((item: any) => ({ ...item, status: 'overQty' })),
					...cartCheck.unnecessary.map((item: any) => ({ ...item, status: 'unnecessary' })),
				];
	const hasWrongItems = wrongList.length > 0;

	return (
		<div className="contentSmallPdTop" data-testid="manu-material-purchase-dashboard">
			<TitleBarWithButton
				history={history}
				title={t('MaterialPurchase.pageTitle')}
				titleIcon="order"
				buttonCheck={true}
				buttonText={t('MaterialPurchase.receipt')}
				buttonOnClick={moveMaterialPurchaseList}
				buttonTestId="manu-material-purchase-receipt-btn"
			/>

			<Box>
				<List className={drawer === false ? classes.list : clsx(classes.list, classes.drawerOpenList)}>
					{material.length != 0 ? (
						material.map((item: any, index: number) => {
							return (
								<ListItem className={classes.materialItem}>
									<MaterialItem
										key={index}
										member={member}
										{...item}
										quantity={getCartQuantity(item.materialCode)}
										setShoppingCart={(e: any, status: string) => setShoppingCart(e, item, status)}
									></MaterialItem>
								</ListItem>
							);
						})
					) : (
						<div className={classes.empty}>
							<div>
								<img src="/images/title/product2.webp" />
								<Typography variant="h1">{t('MaterialPurchase.materialEmpty')}</Typography>
							</div>
						</div>
					)}
					<div ref={loader}></div>
				</List>
			</Box>
			{/* )} */}
			<MaterialBottomBar
				totalPrice={totalPrice}
				totalQuantity={totalQuantity}
				basket={cartWithDetails}
				drawerState={drawer}
				handleOrder={handleOpenPurchasePanel}
				handleBasket={handleDrawerOpen}
			/>
			<SwipeableDrawer
				anchor="bottom"
				open={purchaseOpen}
				onClose={() => setPurchaseOpen(false)}
				onOpen={() => setPurchaseOpen(true)}
				disableSwipeToOpen
				data-testid="manu-material-purchase-panel"
				PaperProps={{ className: classes.drawerPaper }}
				SlideProps={{ onExited: () => setPurchaseStep('product') }}
			>
				<div className={classes.bottomSheet}>
					<div className={classes.sheetHandleArea}>
						<div className={classes.sheetHandle} />
					</div>
					<div className={classes.sheetHeader}>
						{purchaseStep === 'product' ? (
							<Box width={40} />
						) : (
							<IconButton size="small" onClick={() => setPurchaseStep(purchaseStep === 'company' ? 'analysis' : 'product')} aria-label="back">
								<ArrowBack />
							</IconButton>
						)}
						<Typography variant="h2" component="h2">
							{purchaseStep === 'product'
								? t('MaterialPurchase.selectProductTitle')
								: purchaseStep === 'analysis'
									? t('MaterialPurchase.analysisTitle', { name: selectedProductName })
									: t('MaterialPurchase.selectCompany')}
						</Typography>
						<IconButton size="small" onClick={() => setPurchaseOpen(false)} aria-label="close">
							<Close />
						</IconButton>
					</div>

					<div className={classes.sheetContent}>
						{purchaseStep === 'product' && (
							<div className={classes.sheetContentScroll}>
								{productList.length === 0 ? (
									<Typography variant="body1" style={{ textAlign: 'center', padding: '24px 0', color: COLORS.BROWNISH_GREY }}>
										{t('MaterialPurchase.selectProductEmpty')}
									</Typography>
								) : (
									<div className={classes.productGrid}>
										{productList.map((item: any) => {
											let name = getTranslatedLicenseName(tObject, item.productName);
											let selected = selectedProduct?.licenseNum === item.licenseNum;
											return (
												<div
													key={item.licenseNum}
													className={clsx(classes.productCard, selected && classes.productCardSelected)}
													onClick={() => handleSelectProduct(item)}
													data-testid={`manu-material-product-card-${item.licenseNum}`}
												>
													<img className={classes.productCardImage} src={basic.server + '/displayImage?fileName=' + item.productImage} alt="" />
													<Typography variant="subtitle2" style={{ fontFamily: 'NanumB', fontWeight: 'bold' }}>
														{name}
													</Typography>
													<Typography variant="body2">{`Lv.${item.productLicenseLevel}`}</Typography>
													<Typography variant="body2" style={{ color: COLORS.WATER_BLUE, fontWeight: 'bold' }}>
														{formatMoneyAmount(item.productPrice)}
													</Typography>
													<Typography variant="subtitle2" component="span" className={classes.productBadgeComplete}>
														{t('MaterialPurchase.rndComplete')}
													</Typography>
												</div>
											);
										})}
									</div>
								)}
							</div>
						)}

						{showAnalysis && (
							<>
								{hasWrongItems ? (
									<>
										<Box className={classes.analysisAlert}>
											<Typography variant="subtitle2" style={{ fontFamily: 'NanumB', fontWeight: 'bold' }} data-testid="manu-material-analysis-warning-text">
												{t('MaterialPurchase.analysisWarning')}
											</Typography>
											<Typography variant="body2">{t('MaterialPurchase.analysisSummary', { count: wrongList.length })}</Typography>
										</Box>
										<Typography variant="subtitle2" style={{ fontFamily: 'NanumB', fontWeight: 'bold' }} className={classes.analysisSectionTitle}>
											{t('MaterialPurchase.sectionWrong')}
										</Typography>
										<div className={classes.analysisListScroll}>
											{wrongList.map((item: any, index: number) => (
												<MaterialAnalysisItem key={`${item.materialCode}-${item.status}-${index}`} item={item} status={item.status} />
											))}
										</div>
									</>
								) : (
									<Box className={classes.analysisSuccess}>
										<Typography variant="subtitle2" style={{ fontFamily: 'NanumB', fontWeight: 'bold' }}>
											{t('MaterialPurchase.analysisSuccess')}
										</Typography>
									</Box>
								)}
							</>
						)}

						{showCompany && (
							<>
								<Typography variant="subtitle1" style={{ textAlign: 'center', fontFamily: 'NanumB', fontWeight: 'bold', marginBottom: 8 }}>
									{`${t('MaterialPurchase.totalPrice')}: ${formatMoneyAmount(totalPrice)}`}
								</Typography>
								<div className={classes.sheetContentScroll}>
									<div className={classes.productGrid}>
										{companyList.map((item) => {
											const selected = selectedCompany === item.company_num;
											return (
												<div
													key={item.company_num}
													className={clsx(classes.productCard, selected && classes.companyCardSelected)}
													onClick={() => setSelectedCompany(item.company_num)}
													data-testid={`dialog-select-company-radio-${item.company_name}`}
												>
													<Typography variant="subtitle2" style={{ fontFamily: 'NanumB', fontWeight: 'bold' }}>
														{item.company_name}
													</Typography>
												</div>
											);
										})}
									</div>
								</div>
							</>
						)}
					</div>

					<div className={classes.sheetFooter}>
						{purchaseStep === 'product' && (
							<Button className={classes.analyzeBtn} variant="contained" onClick={getLicenseManual} disabled={!selectedProduct} data-testid="manu-material-analyze-btn">
								{t('MaterialPurchase.analyzeMaterials')}
							</Button>
						)}
						{showAnalysis && (
							<Button
								className={classes.analyzeBtn}
								variant="contained"
								onClick={
									hasWrongItems
										? () => setPurchaseOpen(false)
										: companyList.length === 1
											? () => postMaterialOrderCompany(companyList[0].company_num)
											: () => setPurchaseStep('company')
								}
								data-testid={hasWrongItems ? 'manu-material-refill-cart-btn' : 'manu-material-proceed-purchase-btn'}
							>
								{hasWrongItems ? t('MaterialPurchase.refillCart') : companyList.length === 1 ? t('MaterialPurchase.purchase') : t('MaterialPurchase.proceedPurchase')}
							</Button>
						)}
						{showCompany && (
							<Button
								className={classes.analyzeBtn}
								variant="contained"
								onClick={() => postMaterialOrderCompany(selectedCompany)}
								disabled={!selectedCompany}
								data-testid="dialog-select-company-submit-btn"
							>
								{t('MaterialPurchase.confirm')}
							</Button>
						)}
					</div>
				</div>
			</SwipeableDrawer>
		</div>
	);
};

const MaterialAnalysisItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('student');
	const { t: tObject } = useTranslation('object');
	const { item, status } = props;
	const materialName = getTranslatedMaterialName(tObject, item.materialCode, item.materialName);
	const itemClass = status === 'shortage' ? classes.analysisItemShortage : status === 'correct' ? classes.analysisItemCorrect : classes.analysisItemUnnecessary;
	const badgeClass = status === 'shortage' ? classes.analysisBadgeShortage : status === 'correct' ? classes.analysisBadgeCorrect : classes.analysisBadgeUnnecessary;

	let badgeText = '';
	let subText = '';
	if (status === 'shortage') {
		subText = t('MaterialPurchase.currentRequired', { current: item.current, required: item.required });
		badgeText = t('MaterialPurchase.shortageBadge', { n: item.shortage });
	} else if (status === 'correct') {
		subText = t('MaterialPurchase.requiredCount', { n: item.required });
		badgeText = t('MaterialPurchase.correctBadge', { n: item.required });
	} else if (status === 'overQty') {
		subText = t('MaterialPurchase.currentRequired', { current: item.current, required: item.required });
		badgeText = t('MaterialPurchase.unnecessaryBadge', { n: item.extra });
	} else {
		badgeText = t('MaterialPurchase.notNeededBadge');
	}

	return (
		<div className={clsx(classes.analysisItem, itemClass)}>
			<img className={classes.analysisItemImage} src={basic.server + '/displayImage?fileName=' + item.materialImage} alt="" />
			<Box flex={1}>
				<Typography variant="subtitle2" style={{ fontFamily: 'NanumB', fontWeight: 'bold' }}>
					{materialName}
				</Typography>
				{item.materialSubName && (
					<Typography variant="body2" style={{ color: COLORS.BROWNISH_GREY }}>
						{item.materialSubName}
					</Typography>
				)}
				<Typography variant="body2">{subText}</Typography>
			</Box>
			<Typography variant="subtitle2" component="span" className={clsx(classes.analysisBadge, badgeClass)}>
				{badgeText}
			</Typography>
		</div>
	);
};

const MaterialItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation(['object', 'student']);
	const materialName = getTranslatedMaterialName(t, props.materialCode, props.materialName);

	const setCart = (e: any, status: string) => {
		props.setShoppingCart(e, status);
	};
	return (
		<Grid container justify={'center'} alignContent="center">
			<Grid xs={3} className={classes.materialImage}>
				<img src={basic.server + '/displayImage?fileName=' + props.materialImage} />
			</Grid>
			<Grid xs={5} style={{ margin: 'auto' }}>
				<Grid container className={classes.materialDesc} direction="column">
					<Grid id="materialName">{materialName}</Grid>
					{props.materialSubName && <Grid id="materialSubName">{props.materialSubName}</Grid>}
				</Grid>
			</Grid>
			<Grid xs={4}>
				<Grid container className={classes.materialButtonSection} direction="column" alignItems="center">
					<Grid container direction="row">
						<Grid
							xs={4}
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}
						>
							<IconButton style={{ padding: '9px' }}>
								<img className={classes.icon} src={`/images/price.webp`} />
							</IconButton>
						</Grid>
						<Grid xs={4} id="price">
							{formatMoney(props.materialPrice)}
						</Grid>
						<Grid xs={4}></Grid>
					</Grid>
					<Grid container alignItems="center">
						<Grid
							xs={4}
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}
						>
							<IconButton onClick={(e: any) => setCart(e, '-')} style={{ padding: '9px' }}>
								<img className={classes.icon} src={props.quantity > 0 ? `/images/minus_button_blue.webp` : `/images/minus_button.webp`} />
							</IconButton>
						</Grid>
						<Grid xs={4} id="count">
							{props.quantity}
							{t('student:MaterialPurchase.unit')}
						</Grid>
						<Grid
							xs={4}
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}
						>
							<IconButton onClick={(e: any) => setCart(e, '+')} style={{ padding: '9px' }} data-testid={`manu-material-purchase-item-add-btn-${props.materialCode}`}>
								<img className={classes.icon} src={`/images/plus_button_blue.webp`} />
							</IconButton>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

const MaterialBottomBar: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('student');
	const { handleOrder, handleBasket, totalQuantity, totalPrice, drawerState, basket } = props;

	return (
		<div className={drawerState === false ? classes.materialBottomBar : clsx(classes.materialBottomBar, classes.drawerOpenBomttomBar)}>
			{drawerState && (
				<List style={{ height: '21vh', overflowY: 'auto' }}>
					{basket != null &&
						basket.map((item: any, index: number) => {
							return (
								<ListItem>
									<MaterialBasketItem
										index={index}
										quantity={item.quantity}
										materialCode={item.materialCode}
										materialName={item.materialName}
										materialPrice={item.materialPrice}
										materialImage={item.materialImage}
									/>
								</ListItem>
							);
						})}
				</List>
			)}

			<Grid container alignItems="center" alignContent="center" style={{ height: '11vh' }}>
				<Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<Badge badgeContent={totalQuantity} color="error">
						<IconButton onClick={handleBasket} style={{ padding: 0 }}>
							<img className="MaterialBottomicon" src={`/images/title/cart.webp`} />
						</IconButton>
					</Badge>
				</Grid>
				<Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<img className="MaterialBottomicon" style={{ marginRight: '1vw' }} src={`/images/price.webp`} />
					{formatMoney(totalPrice)}
				</Grid>
				<Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<Button onClick={handleOrder} variant="contained" id="saleButton" data-testid="manu-material-purchase-order-btn">
						{t('MaterialPurchase.purchase')}
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

const MaterialBasketItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { quantity, materialCode, materialPrice, materialImage } = props;
	const { t } = useTranslation(['object', 'student']);
	const materialName = getTranslatedMaterialName(t, materialCode, props.materialName);

	return (
		<div className={classes.basketItem}>
			<div id="imageSection">
				<img src={basic.server + '/displayImage?fileName=' + materialImage} />
			</div>

			<div id="nameSection">
				<Typography variant="h2">{materialName}</Typography>
			</div>
			<div id="descSection">
				<Typography
					display="inline"
					variant="h2"
					style={{
						color: `${COLORS.WATER_BLUE}`,
						fontWeight: 'bold',
					}}
				>
					{quantity}
					{t('student:MaterialPurchase.unit')}
				</Typography>
			</div>
			<div id="descSection">
				<Typography
					display="inline"
					variant="h2"
					style={{
						color: `${COLORS.WATER_BLUE}`,
						fontWeight: 'bold',
					}}
				>
					{formatMoney(materialPrice * quantity)}
				</Typography>
			</div>
		</div>
	);
};

export default MaterialPurchase;
